module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-184.d3b41035.svg";